var _g, _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagRibbonWithShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 64 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#tag-ribbon-with-shadow_svg__filter0_f_1797_5862)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 16v57.6L31.998 57.598 16 73.6V16h32zm-4.018 28.178l-8.252 1.754 5.587 6.311-4.885 3.619-4.345-7.296-4.345 7.296-4.976-3.619 5.507-6.133-8.256-1.932 1.863-5.79 7.638 3.309-.619-8.417h6.196l-.973 8.272 7.909-3.26 1.951 5.886z",
    fill: "#131A2D",
    fillOpacity: 0.4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 12v57.6L31.998 53.598 16 69.6V12h32zm-4.018 28.178l-8.252 1.754 5.587 6.311-4.885 3.619-4.345-7.296-4.345 7.296-4.976-3.619 5.507-6.133-8.256-1.932 1.863-5.79 7.638 3.309-.619-8.417h6.196l-.973 8.272 7.909-3.26 1.951 5.886z",
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "tag-ribbon-with-shadow_svg__filter0_f_1797_5862",
    x: 0,
    y: 0,
    width: 64,
    height: 89.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_1797_5862"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iY3VycmVudCIgaGVpZ2h0PSJjdXJyZW50IiB2aWV3Qm94PSIwIDAgNjQgOTAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2ZfMTc5N181ODYyKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNDggMTZWNzMuNkwzMS45OTc5IDU3LjU5ODRMMTYgNzMuNlYxNkg0OFpNNDMuOTgyMSA0NC4xNzgyTDM1LjczMDQgNDUuOTMxOEw0MS4zMTY1IDUyLjI0MzFMMzYuNDMyMyA1NS44NjJMMzIuMDg3MSA0OC41NjY0TDI3Ljc0MTkgNTUuODYyTDIyLjc2NTggNTIuMjQzMUwyOC4yNzI1IDQ2LjEwOTdMMjAuMDE2NiA0NC4xNzgyTDIxLjg4IDM4LjM4ODFMMjkuNTE3NiA0MS42OTY3TDI4Ljg5OTIgMzMuMjgwM0gzNS4wOTUzTDM0LjEyMTggNDEuNTUyTDQyLjAzMSAzOC4yOTI5TDQzLjk4MjEgNDQuMTc4MloiIGZpbGw9IiMxMzFBMkQiIGZpbGwtb3BhY2l0eT0iMC40Ii8+CjwvZz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00OCAxMlY2OS42TDMxLjk5NzkgNTMuNTk4NEwxNiA2OS42VjEySDQ4Wk00My45ODIxIDQwLjE3ODJMMzUuNzMwNCA0MS45MzE4TDQxLjMxNjUgNDguMjQzMUwzNi40MzIzIDUxLjg2MkwzMi4wODcxIDQ0LjU2NjRMMjcuNzQxOSA1MS44NjJMMjIuNzY1OCA0OC4yNDMxTDI4LjI3MjUgNDIuMTA5N0wyMC4wMTY2IDQwLjE3ODJMMjEuODggMzQuMzg4MUwyOS41MTc2IDM3LjY5NjdMMjguODk5MiAyOS4yODAzSDM1LjA5NTNMMzQuMTIxOCAzNy41NTJMNDIuMDMxIDM0LjI5MjlMNDMuOTgyMSA0MC4xNzgyWiIgZmlsbD0iY3VycmVudCIvPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9mXzE3OTdfNTg2MiIgeD0iMCIgeT0iMCIgd2lkdGg9IjY0IiBoZWlnaHQ9Ijg5LjYiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iOCIgcmVzdWx0PSJlZmZlY3QxX2ZvcmVncm91bmRCbHVyXzE3OTdfNTg2MiIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgTagRibbonWithShadow as ReactComponent };